import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import Home from './Pages/Home'
import Found from './Pages/Found'
import MultipleKeysFound from './Pages/MultipleKeysFound'
import NoISNFound from './Pages/NoISNFound'
import WhereIsMyISN from './Pages/WhereIsMyISN'
import NotFound from './Pages/NotFound';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'

class App extends React.Component<any, any> {
    render() {
        return (
            <>
                <Router>
                    <Switch>
                        <Route exact path="/" component={Home} />
                        <Route path="/no-isn-found" component={NoISNFound} />
                        <Route path="/where-is-my-isn" component={WhereIsMyISN} />
                        <Route path="/found/:params?" component={Found} />
                        <Route path="/multiple-key/:email" component={MultipleKeysFound} />
                        <Route path="/404" component={NotFound} />
                        <Route><Redirect to="/" /></Route>
                    </Switch>
                </Router>
            </>
        );
    }
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
